import { UserRoles } from "@intreba/arke-api-client";
import React from "react";
import { useTranslation } from "react-i18next";
export const UserRole = (props: { role: UserRoles }) => {
  const { t } = useTranslation("roles");
  return <span>{t(`${props.role.toString(10)}`)}</span>;
};
